import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import s from './ProgressBar.scss';
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgressBar.prototype.render = function () {
        var _a = this.props, color = _a.color, background = _a.background, percentage = _a.percentage, className = _a.className, barClassName = _a.barClassName, children = _a.children, ariaLabel = _a["aria-label"];
        var limitedPercentage = Math.min(percentage, 100);
        return (React.createElement("div", { "aria-label": ariaLabel, role: "progressbar", "aria-valuenow": Math.floor(limitedPercentage), "aria-valuemin": 0, "aria-valuemax": 100, className: classnames(s['root'], className), style: { background: background } },
            children,
            React.createElement("div", { className: classnames(s['bar'], s['animated'], barClassName), style: {
                    background: color,
                    transform: "scaleX(".concat(limitedPercentage / 100, ")"),
                    transformOrigin: 'left center',
                }, "aria-hidden": "true" })));
    };
    return ProgressBar;
}(React.Component));
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map